import React, {ReactElement} from 'react';

import {pureGetContentType} from 'js-libs/sweetcommons/contentType';

import {gt} from 'app/utils/i18n';

import type {ContentType, DocumentContentType} from 'sweet-types';

export type contentType = ContentType;

export const getContentType = (ct: ContentType) => pureGetContentType(ct, gt);

export const printContentType = (
  ct: ContentType | void,
  className = ''
): ReactElement | null => {
  if (ct == null) {
    return null;
  }

  const ctData = getContentType(ct != null ? ct : 'procedure');
  return (
    <span className={className}>
      {' '}
      <i className={`${ctData.icon}`} /> {ctData.name}
    </span>
  );
};

export const getUnderlyingContentType = <
  T extends
    | {content_type: 'document'; document_content_type: DocumentContentType}
    | {content_type: DocumentContentType}
>(
  object: T
): DocumentContentType =>
  object.content_type === 'document'
    ? object.document_content_type
    : object.content_type;
